import { render, staticRenderFns } from "./Recording.vue?vue&type=template&id=12313b9e&scoped=true&"
import script from "./Recording.vue?vue&type=script&lang=js&"
export * from "./Recording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12313b9e",
  null
  
)

export default component.exports